import React, { useState, useMemo } from "react";
import { FaShieldAlt, FaCheck } from "react-icons/fa";
import useAuth from "../../../../Hooks/useAuth";
import { useAlert } from "../../../../context/AlertContext";
import {
  useGetRoleTemplatesQuery,
  useCreateRoleTemplateMutation,
  useUpdateRoleTemplateMutation,
  useDeleteRoleTemplateMutation,
  useGetTemplateAvailablePermissionsQuery,
} from "../../../../store";
import SettingKeysPicker from "../../../../Components/Firm/Tabs/SettingKeysPicker";
import { Drawer, Modal } from "../../../shared";
import { TextInput, Checkbox } from "../../../../Components/atoms";
import usePermission from "../../../../Hooks/usePermission";
import TemplateRail from "../TemplateRail";
import { ALL_TEMPLATES } from "../../../../utils/templateGrouping";
// Kategori/etiket/alt grup tablolari ORTAK — kullanici izin sekmesi de ayni
// dosyayi kullaniyor (bkz. utils/permissionCatalog.js basindaki not).
import {
  PERMISSION_CATEGORIES,
  PERMISSION_LABELS,
  categoryOf,
  orderCategories,
  getSubGroups,
  migrateLegacyPermissions,
} from "../../../../utils/permissionCatalog";



// Kategori icindeki alt grup tanimlari


// Gosterim kategorisi takma adlari — izin KEY'leri degismeden bir kategori
// baska bir baslik altinda gosterilir. Urun tipi/bilgisi kullanicinin
// gozunde sehir/ilce gibi bir PARAMETRE tanimi; ayri bir baslik olarak
// durmasi listeyi bolüyordu. Key'lere dokunulmaz — dokunulsa mevcut tum
// kullanicilarin izin listesi migrasyon isterdi.


const groupPermissions = (permissions) => {
  const groups = {};
  permissions.forEach((p) => {
    const cat = categoryOf(p.key);
    if (!groups[cat]) groups[cat] = [];
    groups[cat].push(p);
  });
  return groups;
};

// Kategori gösterim sırası — üstte Dashboard, sonra Cihazlar, sonra Bayiler/Müşteriler,
// ardından depo kategorileri. Listede olmayanlar sona eklenir.




// Server tarafindaki permission key'leri ile birebir eslesmeli


/**
 * Izin rozeti etiketi. Once buradaki kisa Turkce ad, yoksa sunucudan gelen
 * aciklama, son care ham key.
 *
 * Sunucu fallback'i bilerek var: izin katalogu server'da buyuyor ve bu map'e
 * eklemeyi unutmak kartlarda "factory.action.uretim" gibi ham key'ler
 * birakiyordu. Fallback sayesinde yeni izin en kotu ihtimalle uzun ama
 * TURKCE bir metinle gorunur.
 */
const getPermissionLabel = (key, descriptions, preferServer = false) =>
  (preferServer && descriptions?.[key]) ||
  PERMISSION_LABELS[key] || descriptions?.[key] || key;

// Rozet rengi ortak util'den — şablon adı serbest olduğu için sabit harita yetmez.

// ─── Template Form Drawer ────────────────────────────────
function TemplateFormDrawer({
  open,
  onClose,
  firmId,
  firmType,
  editTemplate,
  token,
}) {
  // Ayar YAZMA anahtarlari — bolum yetkisi ayari gosterir, bu liste
  // degistirilebilir kilar. Bos = hicbiri (bkz. device-setting-scope.js).
  const [settingWriteKeys, setSettingWriteKeys] = useState(
    editTemplate?.settingWriteKeys || [],
  );
  const [settingReadKeys, setSettingReadKeys] = useState(
    editTemplate?.settingReadKeys || [],
  );
  // Yetkiler / Ayarlar sekmesi — ayar listesi uzun, yetki listesiyle
  // aynı kolonda dikey olarak birikmesin diye ayrıldı.
  const [activeTab, setActiveTab] = useState("permissions");
  const { showSuccess, showError } = useAlert();
  const [createTemplate, { isLoading: creating }] = useCreateRoleTemplateMutation();
  const [updateTemplate, { isLoading: updating }] = useUpdateRoleTemplateMutation();

  const { data: permData } = useGetTemplateAvailablePermissionsQuery(
    { token, firmType },
    { skip: !open || !firmType }
  );

  const availablePermissions = permData?.data?.permissions || [];
  const grouped = useMemo(() => groupPermissions(availablePermissions), [availablePermissions]);

  const [name, setName] = useState(editTemplate?.name || "");
  const [selected, setSelected] = useState(
    new Set(migrateLegacyPermissions(editTemplate?.permissions))
  );
  // Yetenek bayragi — sablon adindan turetilemeyen davranis. Ad serbestce
  // degistirilebildigi icin "bu sablondaki kisiye cihaz atanabilir mi"
  // bilgisi burada acik olarak tutulur.
  // Tam yetki — izin listesi kontrolu atlanir. Sunucu bu bayragi yalnizca
  // admin veya zaten tam yetkili kullanicidan kabul eder (403 aksi halde).
  //
  // BAYI firmalarinda bu secenek YOKTUR (kullanici karari 2026-08-13): sunucu
  // wildcard'i zaten role === "storage" sartina bagli, bayi kullanicisinda
  // isaretli olsa bile yetki listesi uygulanir — etiket yaniltiyordu. Bu tab
  // depo panelinden TUM firma tipleri icin acildigi icin kutucuk burada da
  // gizlenmeli; bayi panelindeki kopyasindan kaldirilmisti.
  //
  // Kural genellestirildi (kullanici karari 2026-09-30): tam yetki YALNIZ
  // depo (Bayiner) firmasinda. Musteri firmasinda ayrica plasiyer (cihaz
  // atama) ve makine ayarlari da yok — musteri kullanicisi makine ayari
  // gormez/degistirmez, cihaz da ona atanmaz.
  const isStorageFirm = firmType === "storage";
  const isCustomerFirm = firmType === "customer";
  const [isFullAccess, setIsFullAccess] = useState(
    editTemplate?.isFullAccess === true
  );
  const [canTakeDevice, setCanTakeDevice] = useState(
    editTemplate?.canTakeDevice === true
  );

  // editTemplate degistiginde formu sifirla
  React.useEffect(() => {
    setName(editTemplate?.name || "");
    setSelected(new Set(migrateLegacyPermissions(editTemplate?.permissions)));
    setCanTakeDevice(editTemplate?.canTakeDevice === true);
    setIsFullAccess(editTemplate?.isFullAccess === true);
    setSettingWriteKeys(editTemplate?.settingWriteKeys || []);
    setSettingReadKeys(editTemplate?.settingReadKeys || []);
  }, [editTemplate]);

  // Erisim ozeti — hangi uygulamaya girilebilecegi AYRI bir bayrakta degil,
  // secilen izinlerde durur (sunucu kapisi: modules/user/domain/userCapability.js).
  //   - AYRI YUZEY onekleri DISINDA en az bir izin → PANEL acilir
  //   - factory.action.* / factory.docs.*           → Okkali Factory tableti
  //   - programming.use (tam yetkili/admin de gecer) → Programlama istasyonu
  //   - hicbiri yok                                 → hicbir yere giris yok (403)
  // Bu ozet olmadan, fabrika/istasyon sablonunu duzenleyen biri farkinda
  // olmadan kullanicilari panelden kilitleyebilir; onu burada goruyor.
  //
  // Asagidaki onek listesi ve istisna sunucudaki userCapability.js ile AYNI
  // olmak zorunda — biri guncellenip digeri unutulursa ozet yalan soyler
  // (ornek: belge izni eklenince "panel acilir" yazardi, sunucu kapatirdi).
  // Okkali Kurumsal izinleri (kurumsal.* / firm.*) panelde sayfa acmaz (#239).
  // "firm." depo/bayi kategorisi "firms."ten ayri bir onek.
  const KURUMSAL_PREFIXES = ["kurumsal.", "firm."];
  const NON_PANEL_PREFIXES = [
    "factory.action.",
    "factory.docs.",
    "programming.",
    ...KURUMSAL_PREFIXES,
  ];
  // "programming.read" panelde GERCEKTEN bir sayfa aciyor (Programlama
  // Islemleri — faaliyet logu), o yuzden onek kuralinin disinda tutulur.
  const PANEL_EXCEPTIONS = new Set(["programming.read"]);
  const isNonPanel = (k) =>
    !PANEL_EXCEPTIONS.has(k) && NON_PANEL_PREFIXES.some((p) => k.startsWith(p));

  const factoryOk = [...selected].some(
    (k) => k.startsWith("factory.action.") || k.startsWith("factory.docs.")
  );
  // Istasyon kapisi TEK izne bakar: "programming.use" (sunucu hasStationAccess
  // + istasyonun kendi _panele_girebilir'i). Kart/ekran izinleri secilip "use"
  // secilmezse kisi istasyona GIREMEZ — ozet bunu eskiden "girer" gosteriyordu.
  const stationOk =
    (isStorageFirm && isFullAccess) || selected.has("programming.use");
  // Sunucu kapisi (auth.middleware.js panelAccessDenied) musteride yalniz TEK
  // durumda kapanir: secim bos degil ve hepsi Kurumsal izni. Bos secimli musteri
  // sablonu bugunku gibi panele girer (eski kayitlar kesilmesin diye).
  const panelOk = isCustomerFirm
    ? !(
        selected.size > 0 &&
        [...selected].every((k) => KURUMSAL_PREFIXES.some((p) => k.startsWith(p)))
      )
    : (isStorageFirm && isFullAccess) || [...selected].some((k) => !isNonPanel(k));
  // Okkali Kurumsal kapisi (sunucu kurumsal-session.js isAllowedForKurumsal):
  // musteri ve bayi "kurumsal.access" izniyle (bayi #278), depo kullanicisi
  // plasiyer bayragiyla girer.
  const kurumsalOk =
    ((isCustomerFirm || firmType === "dealer") && selected.has("kurumsal.access")) ||
    (isStorageFirm && canTakeDevice);

  const togglePermission = (key) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  const toggleCategory = (catPermissions) => {
    const allSelected = catPermissions.every((p) => selected.has(p.key));
    setSelected((prev) => {
      const next = new Set(prev);
      catPermissions.forEach((p) => {
        if (allSelected) next.delete(p.key);
        else next.add(p.key);
      });
      return next;
    });
  };

  const handleSubmit = async () => {
    if (!name.trim()) {
      showError("Şablon adı zorunludur!");
      return;
    }

    // Kural: sablon adi = subRole (server da name'i kaynak alir)
    const payload = {
      token,
      firmId,
      name: name.trim(),
      subRole: name.trim(),
      permissions: [...selected],
      canTakeDevice: isCustomerFirm ? false : canTakeDevice,
      // Depo disinda tam yetki gonderilmez (sunucu da false'a ceker).
      isFullAccess: isStorageFirm ? isFullAccess : false,
      // Musteri sablonunda makine ayari yok — eski bayat anahtarlar da temizlenir.
      settingWriteKeys: isCustomerFirm ? [] : settingWriteKeys,
      settingReadKeys: isCustomerFirm ? [] : settingReadKeys,
    };

    try {
      if (editTemplate) {
        await updateTemplate({ ...payload, templateId: editTemplate._id }).unwrap();
        showSuccess("Rol şablonu güncellendi.");
      } else {
        await createTemplate(payload).unwrap();
        showSuccess("Rol şablonu oluşturuldu.");
      }
      onClose();
    } catch (err) {
      showError(err?.data?.message || "İşlem başarısız oldu.");
    }
  };

  const isSubmitting = creating || updating;

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={editTemplate ? "Şablonu Düzenle" : "Yeni Rol Şablonu"}
      subtitle="Rol şablonu ayarları ve yetkileri"
      titleIcon={<FaShieldAlt className="w-5 h-5 text-orange-500" />}
      width="xl"
    >
      <Drawer.Body className="p-5 space-y-6 flex-1 overflow-y-auto">
        {/* Temel bilgiler — sablon adi ayni zamanda alt rol (subRole) olarak kullanilir */}
        <div className="grid grid-cols-1 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Şablon Adı (Alt Rol)
            </label>
            <TextInput
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="örn: Muhasebe, Saha Sorumlusu"
              disabled={!!editTemplate}
            />
            <p className="text-xs text-gray-400 mt-1">
              Şablon adı, kullanıcıların alt rolü (subRole) olarak da kullanılır.
            </p>
          </div>

          {/* Yetenek — yetki listesiyle ifade edilemeyen davranis. Musteri firmasinda yok. */}
          {!isCustomerFirm && (
          <label className="flex items-start gap-3 rounded-xl border border-gray-200 bg-gray-50/50 p-3.5 cursor-pointer">
            <input
              type="checkbox"
              checked={canTakeDevice}
              onChange={(e) => setCanTakeDevice(e.target.checked)}
              className="mt-0.5 h-4 w-4 accent-orange-500"
            />
            <span>
              <span className="block text-sm font-Medium text-gray-700">
                Cihaz atanabilir (plasiyer)
              </span>
              <span className="block text-xs text-gray-500 mt-0.5">
                İşaretlenirse bu şablondaki kullanıcılar "Plasiyere Ver"
                listesinde görünür ve kurumsal mobil uygulamada plasiyer
                modunda açılır. Şablon adından bağımsızdır.
              </span>
            </span>
          </label>
          )}

          {/* Tam yetki — yetki listesi kontrolunu atlar. Yalniz depo (Bayiner) firmasinda. */}
          {isStorageFirm && (
          <label className="flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50/50 p-3.5 cursor-pointer">
            <input
              type="checkbox"
              checked={isFullAccess}
              onChange={(e) => setIsFullAccess(e.target.checked)}
              className="mt-0.5 h-4 w-4 accent-amber-500"
            />
            <span>
              <span className="block text-sm font-Medium text-gray-700">
                Tam yetkili
              </span>
              <span className="block text-xs text-gray-500 mt-0.5">
                İşaretlenirse aşağıdaki yetki listesi dikkate alınmaz, bu
                şablondaki kullanıcılar her işlemi yapabilir. Yalnızca admin
                veya tam yetkili kullanıcı işaretleyebilir.
              </span>
            </span>
          </label>
          )}

          {/* Erisim ozeti — secili izinlerden turetilir, ayri bir kutucuk yok. */}
          <div
            className={`rounded-xl border p-3.5 ${
              !panelOk && !factoryOk && !stationOk && !kurumsalOk
                ? "border-red-200 bg-red-50/60"
                : !panelOk
                ? "border-blue-200 bg-blue-50/60"
                : "border-gray-200 bg-gray-50/50"
            }`}
          >
            <span className="block text-sm font-Medium text-gray-700">
              Bu şablondaki kullanıcılar nereye girebilir?
            </span>
            <span className="block text-xs text-gray-600 mt-1">
              {(() => {
                const yerler = [
                  panelOk && "panel",
                  factoryOk && "Okkalı Factory tableti",
                  stationOk && "Programlama istasyonu",
                  kurumsalOk && "Okkalı Kurumsal uygulaması",
                ].filter(Boolean);
                if (yerler.length === 0) {
                  return "Hiçbir yere. Hiç yetki seçilmediği için bu kullanıcılar panele giriş yapamaz, fabrika tabletinde de programlama istasyonunda da kart okutamaz.";
                }
                const liste =
                  yerler.length === 1
                    ? yerler[0]
                    : `${yerler.slice(0, -1).join(", ")} + ${yerler[yerler.length - 1]}`;
                // Panel kapaliysa bunu ACIKCA yaz — sablonu duzenleyen kisinin
                // farkinda olmadan kullanicilari panelden kilitlemesi buradan
                // gorulur (sunucu kapisi: userCapability.js hasPanelAccess).
                return panelOk
                  ? `${liste.charAt(0).toUpperCase()}${liste.slice(1)}.`
                  : `Yalnızca ${liste}. Bu kullanıcılar PANELE GİRİŞ YAPAMAZ.`;
              })()}
            </span>
          </div>
        </div>

        {/* Sekme başlıkları — Ayarlar listesi uzun olduğu için ayrı sekme.
            Müşteri firmasında makine ayarı olmadığı için sekme çubuğu hiç yok. */}
        {!isCustomerFirm && (
        <div className="flex items-center gap-1 border-b border-gray-200">
          {[
            { id: "permissions", label: "Yetkiler" },
            { id: "settings", label: "Ayarlar" },
          ].map((t) => (
            <button
              key={t.id}
              type="button"
              onClick={() => setActiveTab(t.id)}
              className={`px-3 py-2 text-sm font-SemiBold border-b-2 -mb-px transition-colors ${
                activeTab === t.id
                  ? "border-main text-gray-900"
                  : "border-transparent text-gray-400 hover:text-gray-600"
              }`}
            >
              {t.label}
              {t.id === "settings" && settingReadKeys.length > 0 && (
                <span className="ml-1.5 text-[11px] text-indigo-600">
                  {settingReadKeys.length}
                </span>
              )}
            </button>
          ))}
        </div>
        )}

        {activeTab === "settings" && !isCustomerFirm && (
          <SettingKeysPicker
            readKeys={settingReadKeys}
            writeKeys={settingWriteKeys}
            onChange={({ readKeys, writeKeys }) => {
              setSettingReadKeys(readKeys);
              setSettingWriteKeys(writeKeys);
            }}
          />
        )}

        {/* Yetkiler */}
        <div className={activeTab === "permissions" || isCustomerFirm ? "" : "hidden"}>
          <h3 className="text-sm font-semibold text-gray-800 mb-3">Yetkiler</h3>
          <div className="space-y-4">
            {orderCategories(Object.entries(grouped)).map(([cat, perms]) => {
              const allChecked = perms.every((p) => selected.has(p.key));
              const someChecked = perms.some((p) => selected.has(p.key));
              const subGroups = getSubGroups(cat, perms);
              return (
                <div
                  key={cat}
                  className="border border-gray-200 rounded-lg p-3"
                >
                  {/* Kategori header */}
                  <div
                    className="flex items-center gap-2 mb-2 cursor-pointer"
                    onClick={() => toggleCategory(perms)}
                  >
                    <div
                      className={`w-4 h-4 rounded border flex items-center justify-center text-xs ${
                        allChecked
                          ? "bg-main border-main text-white"
                          : someChecked
                          ? "bg-primary/30 border-primary"
                          : "border-gray-300"
                      }`}
                    >
                      {allChecked && <FaCheck className="w-2.5 h-2.5" />}
                    </div>
                    <span className="font-medium text-sm text-gray-800">
                      {PERMISSION_CATEGORIES[cat] || cat}
                    </span>
                    <span className="text-xs text-gray-400">
                      ({perms.filter((p) => selected.has(p.key)).length}/{perms.length})
                    </span>
                  </div>

                  {/* Alt gruplu gorunum */}
                  {subGroups ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 ml-2">
                      {subGroups.map((sg) => (
                        <div key={sg.label} className="bg-gray-50 rounded-lg p-2.5">
                          <span className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">
                            {sg.label}
                          </span>
                          <div className="space-y-0.5">
                            {sg.items.map((p) => (
                              <label
                                key={p.key}
                                className="flex items-center gap-2 text-sm text-gray-600 cursor-pointer hover:text-gray-900 py-0.5"
                              >
                                <Checkbox
                                  checked={selected.has(p.key)}
                                  onChange={() => togglePermission(p.key)}
                                />
                                <span>{p.description}</span>
                              </label>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    /* Alt grubu olmayan kategoriler — duz liste */
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-1 ml-6">
                      {perms.map((p) => (
                        <label
                          key={p.key}
                          className="flex items-center gap-2 text-sm text-gray-600 cursor-pointer hover:text-gray-900"
                        >
                          <Checkbox
                            checked={selected.has(p.key)}
                            onChange={() => togglePermission(p.key)}
                          />
                          <span>{p.description}</span>
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </Drawer.Body>
      <Drawer.Footer className="p-4 border-t border-gray-200">
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
          >
            İptal
          </button>
          <button
            onClick={handleSubmit}
            disabled={isSubmitting}
            className="px-4 py-2 text-sm text-white bg-main rounded-lg hover:bg-mainSecond disabled:opacity-50"
          >
            {isSubmitting ? "Kaydediliyor..." : editTemplate ? "Güncelle" : "Oluştur"}
          </button>
        </div>
      </Drawer.Footer>
    </Drawer>
  );
}

// ─── Ana Tab Bileşeni ────────────────────────────────────
/**
 * Kullanıcı şablonları — Kullanıcılar sekmesinin solundaki şablon sütunu
 * (#298; eskiden ayrı sekmede kart ızgarasıydı). Seçim ve kişi sayıları
 * çağırandan (UsersWithTemplatesTab) gelir; çekmece + silme onayı burada.
 */
export default function RoleTemplatesTab({
  firm,
  readOnly,
  selectedId = ALL_TEMPLATES,
  onSelect,
  stats,
}) {
  const { auth } = useAuth();
  const { showSuccess, showError } = useAlert();
  const { hasPermission } = usePermission();

  const { data, isLoading } = useGetRoleTemplatesQuery(
    { token: auth.accessToken, id: firm?._id },
    { skip: !firm?._id }
  );

  const [deleteTemplate, { isLoading: deleting }] = useDeleteRoleTemplateMutation();

  // Kart rozetlerinde etiket fallback'i icin izin katalogu. Drawer da ayni
  // sorguyu kullaniyor; RTK Query ayni argumanla tek istek atar.
  const { data: permData } = useGetTemplateAvailablePermissionsQuery(
    { token: auth.accessToken, firmType: firm?.firmType },
    { skip: !firm?.firmType }
  );
  const permissionDescriptions = useMemo(() => {
    const map = {};
    (permData?.data?.permissions || []).forEach((p) => {
      map[p.key] = p.description;
    });
    return map;
  }, [permData]);

  const templates = data?.data?.templates || [];

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editTemplate, setEditTemplate] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);

  const canCreate = !readOnly && hasPermission("firms.roleTemplatesCreate");
  const canEdit = !readOnly && hasPermission("firms.roleTemplatesEdit");
  const canDelete = !readOnly && hasPermission("firms.roleTemplatesDelete");

  const handleEdit = (template) => {
    setEditTemplate(template);
    setDrawerOpen(true);
  };

  const handleCreate = () => {
    setEditTemplate(null);
    setDrawerOpen(true);
  };

  const handleDelete = async () => {
    if (!deleteTarget) return;
    try {
      await deleteTemplate({
        token: auth.accessToken,
        firmId: firm._id,
        templateId: deleteTarget._id,
      }).unwrap();
      showSuccess("Rol şablonu silindi.");
      if (String(selectedId) === String(deleteTarget._id)) onSelect?.(ALL_TEMPLATES);
      setDeleteTarget(null);
    } catch (err) {
      showError(err?.data?.message || "Silme işlemi başarısız oldu.");
    }
  };

  const dialogs = (
    <>
      {/* Form Drawer — her zaman renderlanmalı */}
      <TemplateFormDrawer
        open={drawerOpen}
        onClose={() => {
          setDrawerOpen(false);
          setEditTemplate(null);
        }}
        firmId={firm?._id}
        firmType={firm?.firmType}
        editTemplate={editTemplate}
        token={auth.accessToken}
      />

      {/* Silme Onay Modal */}
      <Modal open={!!deleteTarget} onClose={() => setDeleteTarget(null)}>
        <Modal.Header title="Şablonu Sil" onClose={() => setDeleteTarget(null)} />
        <Modal.Body>
          <p className="text-sm text-gray-600">
            <strong>{deleteTarget?.name}</strong> rol şablonunu silmek istediğinize emin misiniz?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="flex justify-end gap-3">
            <button
              onClick={() => setDeleteTarget(null)}
              className="px-4 py-2 text-sm text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
            >
              İptal
            </button>
            <button
              onClick={handleDelete}
              disabled={deleting}
              className="px-4 py-2 text-sm text-white bg-fifth rounded-lg hover:bg-red-600 disabled:opacity-50"
            >
              {deleting ? "Siliniyor..." : "Sil"}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );

  // Seçili şablonun özeti: tam yetki ya da yetki sayısı + ilk üç yetki.
  const renderSummary = (t) => {
    const perms = t.permissions || [];
    return (
      <div className="space-y-1.5">
        <p className="text-[11px] text-gray-500">
          {t.isFullAccess ? "Tam yetki" : `${perms.length} yetki`}
        </p>
        {!t.isFullAccess && perms.length > 0 && (
          <div className="flex flex-wrap gap-1">
            {perms.slice(0, 3).map((perm) => (
              <span key={perm} className="px-1.5 py-0.5 text-[10px] bg-gray-100 text-gray-600 rounded" title={perm}>
                {getPermissionLabel(perm, permissionDescriptions, firm?.firmType === "customer")}
              </span>
            ))}
            {perms.length > 3 && (
              <span className="px-1.5 py-0.5 text-[10px] text-gray-400">+{perms.length - 3}</span>
            )}
          </div>
        )}
      </div>
    );
  };
  return (
    <>
      <TemplateRail
        title="Kullanıcı Şablonları"
        accent="indigo"
        templates={templates}
        stats={stats}
        selectedId={selectedId}
        onSelect={onSelect}
        loading={isLoading}
        canCreate={canCreate}
        onCreate={handleCreate}
        canEdit={canEdit}
        onEdit={handleEdit}
        // Varsayilan (sistem) sablonlar silinemez — sunucu da 400 doner.
        canDeleteTemplate={(t) => canDelete && t.isSystem !== true}
        onDelete={setDeleteTarget}
        renderSummary={renderSummary}
      />
      {dialogs}
    </>
  );
}
